import { Component, inject } from '@angular/core';
import { WebAuthService, WebAuthModule, LoginComponent } from '@rbb/ng-web-auth-lib';
import { NavbarComponent } from './components/navbar/navbar.component';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from '@rbb/ng-web-template-lib';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  imports: [NavbarComponent, RouterOutlet, WebAuthModule, LoginComponent, LoaderComponent]
})
export class AppComponent {
  webAuthService = inject(WebAuthService);
}
